import { render } from "./Premium.vue?vue&type=template&id=75fb5bb1&scoped=true&ts=true"
import script from "./Premium.vue?vue&type=script&lang=ts"
export * from "./Premium.vue?vue&type=script&lang=ts"

import "./Premium.vue?vue&type=style&index=0&id=75fb5bb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fb5bb1"]])

export default __exports__